export default __webpack_public_path__ + "static/appStoreIcon-0e37a7ddb56ceacf5c222593de0c1a59.svg";